import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.PressRoomListingView.heading',
    defaultMessage: 'Press Room'
  },
  lastAdded: {
    id: 'views.PressRoomListingView.lastAdded',
    defaultMessage: 'OSTATNIO DODANE'
  },
  nothingToShow: {
    id: 'views.PressRoomListingView.nothingToShow',
    defaultMessage: 'Brak artykułów do wyświetlenia'
  },
  others: {
    id: 'views.PressRoomListingView.others',
    defaultMessage: 'POZOSTAŁE'
  },
  categories: {
    id: 'views.PressRoomListingView.categories',
    defaultMessage: 'KATEGORIE'
  },
  taxonomyAll: {
    id: 'views.PressRoomListing.categories.all',
    defaultMessage: 'Wszystkie'
  },
  publicationDate: {
    id: 'views.PressRoomListing.publicationDate',
    defaultMessage: 'DATA PUBLIKACJI'
  },
  filter: {
    id: 'views.PressRoomListing.filter.all',
    defaultMessage: 'Wszystkie'
  },
  tag1: {
    id: 'views.PressRoomListing.tag1',
    defaultMessage: 'Case Studies'
  },
  tag2: {
    id: 'views.PressRoomListing.tag2',
    defaultMessage: 'Nasi eksperci'
  },
  tag3: {
    id: 'views.PressRoomListing.tag3',
    defaultMessage: 'Media o nas'
  },
  button: {
    id: 'views.PressRoomListing.button',
    defaultMessage: 'Zobacz więcej ...'
  },
  journalistContact: {
    id: 'views.PressRoomListing.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  }
});



// WEBPACK FOOTER //
// ./src/views/PressRoomListing/PressRoomListingView.intl.js